import {
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemText,
  Paper,
} from "@mui/material";
import { useMaterialUIController } from "context";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import SearchIcon from "@mui/icons-material/Search";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { setAction } from "context";

export default function ListComponent(props) {
  const [search, setSearch] = useState("");
  const [menu, setMenu] = useState(props.selectedQuestion.answers);

  const {
    selectedQuestion,
    editQuestionValueHandle,
    handleClose,
    helpPage,
    setFocuse,
  } = props;
  const [controller, dispatch] = useMaterialUIController();
  return (
    <div>
      <Paper
        component="form"
        style={{
          padding: "1px 4px",
          display: "flex",
          alignItems: "center",
          margin: 0,
          left: 0,
          with: "100% !important",
          right: 0,
          top: 0,
          position: "relative",
          borderRadius: 0,
          backgroundColor: "#ffc7d4",
          zIndex: 9999,
        }}
      >
        <IconButton
          color="primary"
          aria-label="CloseIcon"
          onClick={() => {
            setSearch("");
            setMenu(selectedQuestion.answers);
          }}
        >
          <CloseIcon />
        </IconButton>
        <InputBase
          value={search}
          fullWidth={true}
          autoFocus={true}
          onChange={(event) => {
            setSearch(event.target.value);
            if (event.target.value.length > 0) {
              let smenu = [];
              smenu = selectedQuestion.answers.filter((a) =>
                a.answer
                  .toLowerCase()
                  .includes(event.target.value.toLowerCase())
              );
              setMenu(smenu);
            } else {
              setMenu(selectedQuestion.answers);
            }
          }}
        />

        <IconButton color="primary" aria-label="search">
          <SearchIcon />
        </IconButton>
      </Paper>

      <div className="listmenu" style={{ paddingRight: 15, paddingLeft: 15 }}>
        <List style={{ display: "flex", flexWrap: "wrap" }}>
          {menu &&
            menu.map((item, index) => (
              <ListItem
                style={{
                  width:
                    selectedQuestion.answerSize &&
                    selectedQuestion.answerSize == 6
                      ? "48%"
                      : "100%",
                  marginRight:
                    selectedQuestion.answerSize &&
                    selectedQuestion.answerSize == 6
                      ? "2%"
                      : 0,
                }}
                className={
                  item.id + "" === selectedQuestion.useranswer + ""
                    ? "drawerlistselected"
                    : "drawerlist"
                }
                key={item.id}
                autoFocus
                button
                onClick={() => {
                  setTimeout(() => {
                    handleClose();
                    editQuestionValueHandle(selectedQuestion, item.id);
                    setFocuse(selectedQuestion.code);
                    if (item.help) {
                      helpPage(item.help);
                    } else {
                      if (item.isNext && props.headline !== "scores") {
                        setAction(dispatch, "nextpage" + new Date());
                      }
                      if (item.isBack && props.headline !== "scores") {
                        setAction(dispatch, "backpage" + new Date());
                      }
                    }
                  }, 100);
                  //if (item.id + "" !== props.selectedQuestion.useranswer + "") {

                  //}
                }}
              >
                <ListItemText
                  primary={item.answer}
                  className={{
                    color:
                      item.id + "" === selectedQuestion.useranswer + ""
                        ? "drawerlistselectedtext"
                        : "drawerlitext",
                  }}
                />
                {item.help && (
                  <MoreVertIcon
                    style={{
                      position: "absolute",
                      color:
                        item.id + "" === selectedQuestion.useranswer + ""
                          ? "#FFF"
                          : "#039dfc",
                      width: 15,
                      height: 15,
                      right: 0,
                      top: 1,
                    }}
                  />
                )}
              </ListItem>
            ))}
        </List>
      </div>
    </div>
  );
}
